import { Component, Input } from '@angular/core';
import { ErrorTransformationLogItem } from '../../model/error-transformation-log-item';
import { LogItemHelper } from '../log-item-helper';
import { AbregelungFREAnwenderadresse } from '../../../domain/model/abregelungsinformationen-fre-anwenderadresse.enum';

@Component({
    selector: 'redispatch-error-transformationlogitem',
    templateUrl: './error-transformation-log-item.component.html',
    styleUrls: [
        './error-transformation-log-item.component.scss',
    ],
    standalone: false,
})
export class ErrorTransformationLogItemComponent {

    @Input()
        errorTransformationLogItem: ErrorTransformationLogItem;

    public formatArray = LogItemHelper.formatArray;

    constructor() {
    }

    abregelungFREAnwenderadressen = Object.values(AbregelungFREAnwenderadresse);
}
